module.exports = __webpack_public_path__ + "static/img/gaoxiaoUse.f61bea9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gaoxiaoUse.jpg
// module id = yJXz
// module chunks = 0